import styled from 'styled-components'
import { Button } from 'toonswap-uikit'

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 20px;
  border: 3px solid #252c2d;
  border-radius: 26px;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
  background: #374244;
  gap: 12px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin: 0;
    max-height: none;
  }
`

export const ActionTitles = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #b0b0b0;
`

export const Title = styled.span`
  color: #e0e0e0;
`

export const Subtle = styled.span`
  color: #b0b0b0;
`

export const ActionContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

export const Earned = styled.div`
  font-weight: 600;
  font-size: 30px;
  color: #e0e0e0;
`

export const Staked = styled.div`
  font-size: 14px;
  color: #ffffff;
`

export const StyledPrimaryButton = styled(Button)`
  min-height: 34px !important;
  padding: 0 10px !important;
  background: #fe7b2a !important;
  color: #ffffff !important;
  border: 2px solid #2b3335 !important;
  border-radius: 10px !important;
  font-weight: 600;
  font-size: 12px !important;

  &:hover:not(:disabled) {
    opacity: 0.9;
    background: #fe7b2a !important;
    color: #ffffff !important;
  }
  &:disabled {
    opacity: 0.5;
  }
  @media (min-width: 375px) {
    min-height: 36px !important;
    padding: 0 12px !important;
  }
  @media (min-width: 768px) {
    min-height: 40px !important;
    padding: 0 16px !important;
    border-width: 3px !important;
    border-radius: 12px !important;
    font-size: 14px !important;
  }
`

export const ValueWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0px;
  gap: 20px;

  > div:first-child,
  > span:first-child {
    color: #b0b0b0;
    font-size: 14px;
  }
`
